export const getHubspotScriptSrc = (code: string) => {
  return `//js.hs-scripts.com/${code}.js`
}
